import Vue from "vue";
import Router from "vue-router";
import { UserStore, RoleStore } from "./store";

Vue.use(Router);

export const ROUTES = {
  home: "home",
  admin: "admin",
  clients: "clients",
  riskprofiler: "riskprofiler",
  riskprofilerresults: "riskprofilerresults",
  confirmEmail: "confirmemail",
  policies: "policies",
  policyDetailsProtection: "policyDetailsProtection",
  policyDetailsInvestment: "policyDetailsInvestment",
  policyDetailsPension: "policyDetailsPension",
  changePassword: "changepassword",
  dashboard: "dashboard",
  profile: "profile",
  factfind: "factfind",
  logout: "logout",
  landing: "landing",
  forgotPassword: "forgotPassword",
  resetPassword: "resetPassword",
  sessionTimeout: "sessionTimeout",
  advisorClientView: "advisorClientView"
};

const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/landing/:companyid",
      name: ROUTES.landing,
      component: () => import("@/views/system/LandingPage.vue"),
      meta: { IsLoggedIn: false }
    },
    {
      path: "/home",
      name: ROUTES.home,
      component: () => import("@/views/system/Home.vue")
    },
    {
      path: "/admin",
      name: ROUTES.admin,
      component: () => import("@/views/admin/Admin.vue"),
      meta: { IsLoggedIn: true, HasAdminRole: true }
    },
    {
      path: "/confirmemail",
      name: ROUTES.confirmEmail,
      component: () => import("@/views/auth/ConfirmEmail.vue")
    },
    {
      path: "/policies/:contactId",
      name: ROUTES.policies,
      component: () => import("@/views/policies/Policies.vue"),
      meta: { IsLoggedIn: true }
    },
    {
      path: "/policies/:contactId/protection/:policyId",
      name: ROUTES.policyDetailsProtection,
      component: () => import("@/views/policies/PolicyDetails_Protection.vue"),
      meta: { IsLoggedIn: true }
    },
    {
      path: "/policies/:contactId/investment/:policyId",
      name: ROUTES.policyDetailsInvestment,
      component: () => import("@/views/policies/PolicyDetails_Investment.vue"),
      meta: { IsLoggedIn: true }
    },
    {
      path: "/policies/:contactId/pension/:policyId",
      name: ROUTES.policyDetailsPension,
      component: () => import("@/views/policies/PolicyDetails_Pension.vue"),
      meta: { IsLoggedIn: true }
    },
    {
      path: "/dashboard",
      name: ROUTES.dashboard,
      component: () => import("@/views/users/Dashboard.vue"),
      meta: { IsLoggedIn: true }
    },
    {
      path: "/factfind/:contactId",
      name: ROUTES.factfind,
      component: () => import("@/views/factFind/_FactFindMain.vue")
    },
    {
      path: "/riskprofiler",
      name: ROUTES.riskprofiler,
      component: () => import("@/views/riskProfile/RiskProfiler.vue"),
      meta: { IsLoggedIn: true, HasRiskProfileInputRole: true }
    },
    {
      path: "/riskprofiler/results",
      name: ROUTES.riskprofilerresults,
      component: () => import("@/views/riskProfile/RiskProfileResults.vue"),
      meta: { IsLoggedIn: true, HasRiskProfileInputRole: true }
    },
    {
      path: "/logout",
      name: ROUTES.logout,
      component: () => import("@/views/auth/Logout.vue"),
      meta: { IsLoggedIn: true }
    },
    {
      path: "/reset-password/:userid/:token",
      name: ROUTES.resetPassword,
      component: () => import("@/views/auth/ResetPassword.vue"),
      meta: { IsLoggedIn: false }
    },
    {
      path: "/forgot-password",
      name: ROUTES.forgotPassword,
      component: () => import("@/views/auth/ResetPassword.vue"),
      meta: { IsLoggedIn: false }
    },
    {
      path: "/session-timeout",
      name: ROUTES.sessionTimeout,
      component: () => import("@/views/auth/SessionTimeout.vue"),
      meta: { IsLoggedIn: true }
    },
    {
      path: "/advisorclientview/:contactId",
      name: ROUTES.advisorClientView,
      component: () => import("@/views/broker/AdvisorClientView.vue"),
      meta: { IsLoggedIn: true }
    },
    {
      path: "*",
      redirect: "/home"
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  // Is Logged In
  if (to.matched.some(record => record.meta.IsLoggedIn)) {
    if (!UserStore.loggedInUser) {
      next({
        name: ROUTES.home,
        query: { redirect: to.fullPath }
      });
      return;
    }
  }

  // Has Adviser Role
  if (to.matched.some(record => record.meta.HasAdvisorRole)) {
    if (!RoleStore.isAnAdvisor) {
      next({
        name: ROUTES.home,
        query: { redirect: to.fullPath }
      });
      return;
    }
  }

  // Has Admin Role
  if (to.matched.some(record => record.meta.HasAdminRole)) {
    if (!RoleStore.isAnAdmin) {
      next({
        name: ROUTES.home,
        query: { redirect: to.fullPath }
      });
      return;
    }
  }

  // Has Risk Profile Input Role
  if (to.matched.some(record => record.meta.HasRiskProfileInputRole)) {
    if (!RoleStore.isRiskProfileUser) {
      next({
        name: ROUTES.home,
        query: { redirect: to.fullPath }
      });
      return;
    }
  }

  next(); // make sure to always call next()!
});

export default router;
